export enum EPromoCodeStatus {
  Button = 'button',
  Form = 'form',
  Checking = 'checking',
  Accepted = 'accepted',
  Rejected = 'rejected',
}
